import * as Cesium from 'cesium';
import { APP_CONFIG, QUALITY_SETTINGS } from '../config/appConfig';

export function createViewer(container: Element | string): Cesium.Viewer {
  const viewer = new Cesium.Viewer(container, {
    animation: false,
    baseLayerPicker: false,
    baseLayer: false,
    fullscreenButton: false,
    geocoder: false,
    homeButton: false,
    infoBox: false,
    navigationHelpButton: false,
    sceneModePicker: false,
    selectionIndicator: false,
    timeline: false,
    scene3DOnly: true,
    shouldAnimate: false,
    showRenderLoopErrors: false,
    useBrowserRecommendedResolution: true,
    requestRenderMode: true,
    maximumRenderTimeChange: Number.POSITIVE_INFINITY,
    msaaSamples: 1,
    shadows: QUALITY_SETTINGS[APP_CONFIG.defaultQuality].shadows,
    terrainShadows: QUALITY_SETTINGS[APP_CONFIG.defaultQuality].shadows
      ? Cesium.ShadowMode.ENABLED
      : Cesium.ShadowMode.DISABLED,
    terrainProvider: new Cesium.EllipsoidTerrainProvider(),
  });

  viewer.scene.globe.depthTestAgainstTerrain = true;
  viewer.scene.screenSpaceCameraController.enableCollisionDetection = false;

  viewer.scene.renderError.addEventListener((error) => {
    // 1枚のタイルや一時的なWebGLエラーでアプリ全体を停止させない。
    console.error('[Cesium render error]', error);
    viewer.scene.requestRender();
  });

  viewer.scene.requestRender();
  return viewer;
}
